import React from 'react'

const FormField = ({containerClass, id, label, required, type, autoComplete, placeholder, value}) => {
    return (
        <div className={containerClass}>
            {type !== 'checkbox' &&
                <label htmlFor={id} className="sr-only">
                    {label}
                    {required && <span className="text-red">*</span>}
                </label>
            }
            {type === 'text' &&
                <input
                    type={type}
                    name={id}
                    id={id}
                    required={required ? true : false}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    defaultValue={value ? value : ''}
                    className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] font-display text-lg"
                />
            }
            {type === 'email' &&
                <input
                    type={type}
                    name={id}
                    id={id}
                    required={required ? true : false}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    defaultValue={value ? value : ''}
                    className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] font-display text-lg"
                />
            }
            {type === 'file' &&
            <>
                <label htmlFor={id} className="font-display">
                    Add attachment
                </label> 
                <input
                    type={type}
                    name={id}
                    id={id}
                    required={required ? true : false}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    defaultValue={value ? value : ''}
                    className="block w-full shadow-sm py-3 pr-4 placeholder-placeholdergrey font-display focus:ring-darkred focus:border-darkred border-[#e0e0e0]"
                />
            </>
            }
            {type === 'checkbox' &&
            <>
                <input
                    type={type}
                    name={id}
                    id={id}
                    required={required ? true : false}
                    defaultValue={value ? value : ''}
                    className="inline-block text-xs font-base mr-3 focus:ring-darkred focus:border-darkred border-[#e0e0e0] checked:!bg-red"
                />
                <label htmlFor={id} className="">
                    I can confirm I have read and agree to the TLF Research Ltd <a href='/privacy-policy' className='text-red'>Privacy Policy.</a>
                    {required && <span className="text-red">*</span>}
                </label> 
            </>
            }
            {type === 'textarea' &&
                <textarea
                    id={id}
                    name={id}
                    rows={4}
                    placeholder={placeholder}
                    className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] font-display text-lg"
                    defaultValue={value ? value : ''}
                />
            }
        </div>
    )
}

export default FormField